import Serializer from './application';

export default Serializer.extend({
  attrs: {
    topCategory: 'topCategoryId',
  },
});
